<i18n>
{
  "cl": {
    "debtor": "Deudor"
  }
}
</i18n>
<template>
  <div class="box">
    <div class="participan-header">
      <div class="columns is-vcentered">
        <div class="column">
          <small class="has-text-grey-light">
            {{ $t('debtor') }}
          </small>
          <h3 class="has-text-black m-0">{{ debtor.fullName }}</h3>
        </div>
      </div>
    </div>
    <div class="participan-tags">
      <b-tag
        type="is-primary is-light mr-4"
        icon="fingerprint"
        data-cy="id-number"
        rounded>
        {{ debtor.idNumber }}
      </b-tag>
      <b-tag
        v-if="debtor.birthdate !== '' && debtor.birthdate !== null && debtor.birthdate !== '0000-00-00'"
        type="is-primary is-light mr-4"
        icon="calendar-days"
        data-cy="birthdate"
        rounded>
        {{ beforeFormatDate(debtor.birthdate) }}
      </b-tag>
      <b-tag
        type="is-primary is-light mr-4"
        icon="envelope"
        rounded>
        {{ debtor.email }}
      </b-tag>
    </div>
    <div class="evaluations-documents">
      <b-button
        v-for="(document, index) in evidenceData"
        :key="index"
        size="is-small"
        type="mr-4"
        icon-left="download"
        tag="a"
        :href="`data:application/pdf;base64,${document.pdfBase64}`"
        :download="document.pdfFileName"
        rounded>
        {{ document.pdfFileName }}
      </b-button>
      <!--      <b-button-->
      <!--        class="add"-->
      <!--        size="is-small"-->
      <!--        icon="plus"-->
      <!--        type="mr-4 mb-1"-->
      <!--        icon-left="plus"-->
      <!--        rounded-->
      <!--        @click="selectDocument" />-->
      <input
        ref="fileInput"
        type="file"
        accept="application/pdf"
        hidden
        @change="handleFileUpload">
    </div>
  </div>
</template>

<script>

import { formatDate } from '@/infrastructure/format';

export default {
  name: 'EvaluationDebtor',
  props: {
    debtor: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      evidenceData: [],
      evidence: {
        EvaluacionAutomaticaRutFloid: 'Reporte Floid',
        EvaluacionAutomaticaRutEquifax: 'Reporte Deuda',
        EvaluacionAutomatica: 'SBIF - GESINTEL - Poder Judicial',
        Preaprobacion: 'Carta Preaprobacion',
        Simulacion: 'Simulacion'
      },
      addDocument: false
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    formatDate,
    beforeFormatDate(date) {
      const dateToSend = date ? new Date(`${date} 00:00:00`) : null;
      return dateToSend ? formatDate(dateToSend) : '';
    },
    changeDocumentName(evidences) {
      const evidencesFiltered = evidences.filter(Boolean);

      evidencesFiltered.forEach(document => {
        const [prefijo, second] = document.pdfFileName.split('-');
        const prefix = prefijo === 'Carta' ? second : prefijo;
        const name = this.evidence[prefix] || 'Nombre no encontrado';
        this.evidenceData.push({ pdfFileName: name, pdfBase64: document.pdfBase64 });
      });
    },
    async fetchData() {
      try {
        const evidences = [this.debtor.reports.income, this.debtor.reports.debt, ...this.debtor.reports.others];
        this.changeDocumentName(evidences);
      } catch (_error) {
        this.$log.error('No se pudo cargar los documentos de la evaluación');
      }
    },
    selectDocument() {
      this.$refs.fileInput.click();
    },
    handleFileUpload(event) {
      const [file] = event.target.files;
      if (file) {
        this.evidenceData.push({
          pdfFileName: file.name
        });
        this.$refs.fileInput.value = '';
      }
    }
  }
};
</script>

<style scoped>
.box{
  padding: 10px 25px;
  border-radius: 10px;
}
h3{
  font-size: 1.5rem;
}
.participan-tags{
  margin: 0.25em 0 1em 0;
}
</style>
<style>

</style>
